import { render, staticRenderFns } from "./manual-payment.vue?vue&type=template&id=e65827b6&scoped=true"
import script from "./manual-payment.vue?vue&type=script&lang=ts"
export * from "./manual-payment.vue?vue&type=script&lang=ts"
import style0 from "./manual-payment.vue?vue&type=style&index=0&id=e65827b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65827b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDataTableHeader } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDataTableHeader,VSpacer,VTextField})
